import { BaseModel } from "./base";

import { TipoVeiculo } from "./tipo_veiculo";
import Cor from "./cor";
import Combustivel from "./combustivel";
import ModeloCarroceria from "./modeloCarroceria";
import MarcaChassi from "./marcaChassi";
import MarcaModelo from "./marcaModelo";
import Uf from "./uf";
import SituacaoDividaAtiva from "./situacaoDividaAtiva";
import VeiculoTransportadora from "./veiculoTransportadora";

export class Veiculo {
  constructor(
    public id?: number,
    public placa?: string,
    public tipoVeiculo?: TipoVeiculo,
    public chassiNumero?: string,
    public cor?: Cor,
    public potencia?: number,
    public lotacaoSentados?: number,
    public lotacaoEmPe?: number,
    public combustivel?: Combustivel,
    public possuiAr?: boolean,
    public possuiSanitario?: boolean,
    public possuiWifi?: boolean,
    public possuiAcessibilidade?: boolean,
    public renavam?: number,
    public createdAt?: Date,
    public updatedAt?: Date,
    public deletedAt?: Date,
    public ultAnoLicenciamento?: number,
    public modeloCarroceria?: ModeloCarroceria,
    public marcaChassi?: MarcaChassi,
    public marcaModelo?: MarcaModelo,
    public ufJurisdicao?: Uf,
    public ultimaVistoria?: Date,
    public horaVistoria?: Date,
    public hora?: string,
    public validadeVistoriaAux?: Date,
    public chassiAno?: number,
    public anoFabricacao?: number,
    public dataNf?: Date,
    public carroceriaAnofabricacao?: number,
    public veiculosTransportadoras?: VeiculoTransportadora[],
    public situacaoDividaAtiva?: SituacaoDividaAtiva,
    public chaveAcessoNfe?: string,
  ) {

  }
}

